<section class="waitlisted-page">
  <div class="page-header">
    <div>
      <h3 class="title">Waitlisted Users</h3>
      <p class="subtitle">Manage interest collected from the coming-soon waitlist.</p>
    </div>
  </div>

  <div class="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-3">
    <div class="d-flex align-items-center gap-3">
      <app-search-box tooltipText="Search By firstName, lastName, email, and phone" (search)="onSearch($event)"></app-search-box>

      <!-- Contact Method -->
      <p-select class="dropdown" [options]="contactMethods" optionLabel="label" optionValue="value" [showClear]="true"
        placeholder="Contact Method" [ngModel]="contactMethodFilter()"
        (ngModelChange)="contactMethodFilter.set($event); onFilterChange()">
      </p-select>

      <!-- Lead Source -->
      <p-select class="dropdown" [options]="leadSources" optionLabel="label" optionValue="value" [showClear]="true"
        placeholder="Lead Source" [ngModel]="leadSourceFilter()"
        (ngModelChange)="leadSourceFilter.set($event); onFilterChange()">
      </p-select>

      @if (hasSelection()) {
        <button class="btn btn-icon btn-delete-bulk tooltip-wrap" (click)="deleteSelectedUsers()">
          <i class="pi pi-trash" style="font-size: 1.25rem;"></i>
          <span class="tooltip-box">Delete Selected</span>
        </button>
      }
    </div>

    <div class="d-flex align-items-center gap-3 ms-auto">
      <div class="d-flex align-items-center gap-2 border rounded px-1 header-icon-actions-wrapper">
        <button type="button" class="btn btn-icon p-1 header-icon-action-btn" (click)="fetchUsers()" title="Refresh">
          <i class="pi pi-refresh" style="font-size: 1.25rem; color: #6b7280;"></i>
        </button>
        <button type="button" class="btn btn-icon p-1 tooltip-wrap header-icon-action-btn" (click)="toggleIncludeDeleted()">
          <i class="pi pi-asterisk" style="font-size: 1.25rem;" [style.color]="includeDeleted() ? '#ec4899' : '#6b7280'"></i>
          <span class="tooltip-box">Include Mark Deleted</span>
        </button>
      </div>
    </div>
  </div>

  <div class="table-container shadow">
    <table class="waitlist-table">
      <thead>
        <tr>
          <th width="48" class="checkbox-col">
            <input type="checkbox" [checked]="allSelected()" (change)="toggleSelectAll()" />
          </th>
          <th class="sortable" (click)="onSort('name')">
            Name <span class="sort-indicator" [class.active]="currentSortField() === 'name'">{{ getSortIcon('name') }}</span>
          </th>
          <th class="sortable" (click)="onSort('email')">
            Email <span class="sort-indicator" [class.active]="currentSortField() === 'email'">{{ getSortIcon('email') }}</span>
          </th>
          <th class="sortable" (click)="onSort('phone')">
            Phone <span class="sort-indicator" [class.active]="currentSortField() === 'phone'">{{ getSortIcon('phone') }}</span>
          </th>
          <th class="sortable" (click)="onSort('preferredContactMethod')">
            Contact <span class="sort-indicator" [class.active]="currentSortField() === 'preferredContactMethod'">{{ getSortIcon('preferredContactMethod') }}</span>
          </th>
          <th class="sortable" (click)="onSort('leadSource')">
            Source <span class="sort-indicator" [class.active]="currentSortField() === 'leadSource'">{{ getSortIcon('leadSource') }}</span>
          </th>
          <th class="sortable" (click)="onSort('createdAt')">
            Submitted <span class="sort-indicator" [class.active]="currentSortField() === 'createdAt'">{{ getSortIcon('createdAt') }}</span>
          </th>
          <th class="text-center">Action</th>
        </tr>
      </thead>

      <tbody>
        @if (loading()) {
          <tr>
            <td colspan="8">
              <app-spinner-loader [width]="35"></app-spinner-loader>
            </td>
          </tr>
        }
        @else if (users().length === 0) {
        <tr>
          <td colspan="9" class="no-data-cell">No waitlisted user found</td>
        </tr>
      }
      <!-- REPLACE the entire @else block: -->
      @else {
      @for (u of users(); track u.id) {
        <tr [ngClass]="{'deleted-row': !!u.deletedAt}" [class.selected]="u.selected">
          <td class="checkbox-col">
            <input type="checkbox" [(ngModel)]="u.selected" (change)="updateSelectAllState()" [disabled]="!!u.deletedAt" />
          </td>
          <td>
            <div class="d-flex align-items-center gap-2">
              <span class="fw-semibold">
                {{
                (
                (u.firstName || (u.fullName?.split(' ')?.[0] ?? '')) + ' ' +
                (u.lastName || (u.fullName?.split(' ')?.[1] ?? ''))
                ) | titlecase
                }}
              </span>
            </div>
          </td>
          <td>{{ u.email || 'N/A'}}</td>
          <td>{{ u.phone || 'N/A' }}</td>
          <td>{{ getPreferredContactMethod(u.preferredContactMethod)}}</td>
          <td>{{ getLeadSourceLabel(u.leadSource) || 'N/A'}}</td>
          <td>{{ u.createdAt | date:'mediumDate' }}</td>
          <td class="text-center">
            <button class="btn btn-view" (click)="viewUser(u)">View</button>
          </td>
        </tr>
      }
    }
  </tbody>
</table>

<div class="pagination-section">

  <!-- LEFT -->
  <div class="pagination-info">
    Showing {{ startIndex }} to {{ endIndex }} of {{ totalCount() }} Entries
  </div>

  <!-- RIGHT -->
  <div class="pagination-right">

    <div class="page-size">
      <label>Page Size:</label>
      <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)">
        @for (size of pageSizes; track size) {
          <option [value]="size">{{ size }}</option>
        }
      </select>
    </div>

    <div class="pagination-buttons">
      <button class="btn btn-outline pagination-btn" [disabled]="currentPage() === 1 || loading()"
        (click)="previousPage()">
        &lt; Prev
      </button>

      <button class="btn btn-outline pagination-btn" [disabled]="currentPage() === totalPages|| loading()"
        (click)="nextPage()">
        Next &gt;
      </button>
    </div>

  </div>
</div>
</div>
</section>
@if (showViewModal() && selectedUser()) {
  <div class="modal-overlay">
    <div class="modal-card">

      <!-- Header with gradient -->
      <div class="modal-header-gradient">
        <div class="modal-title-row">
          <h5>User Details</h5>
          <span class="modal-badge" [class]="selectedUser()!.isOptionalFieldEnabled ? 'badge-full' : 'badge-basic'">
            {{ selectedUser()!.isOptionalFieldEnabled ? 'FULL' : 'BASIC' }}
          </span>
        </div>
        <p class="modal-timestamp">{{ selectedUser()!.createdAt | date:'medium' }}</p>
        <button class="modal-close-btn" (click)="closeModal()">✕</button>
      </div>

      <div class="modal-body">

        <!-- Basic Information -->
        <div class="modal-section">
          <h6 class="section-title"><i class="pi pi-info-circle"></i> Basic Information</h6>
          <div class="detail-row"><span class="label">ID</span><span class="value-mono">{{ selectedUser()!.id }}</span>
        </div>
        <div class="detail-row"><span class="label">NAME</span><span>{{ selectedUser()!.firstName }} {{
      selectedUser()!.lastName }}</span></div>
      <div class="detail-row"><span class="label">EMAIL</span><span>{{ selectedUser()!.email || 'N/A' }}</span></div>
      <div class="detail-row"><span class="label">PHONE</span><span>{{ selectedUser()!.phone || 'N/A' }}</span></div>
    </div>

    <hr class="modal-divider" />

    <!-- Metadata -->
    <div class="modal-section">
      <h6 class="section-title"><i class="pi pi-list"></i> Metadata</h6>
      <div class="meta-grid">
        <div class="meta-card">
          <div class="meta-icon purple"><i class="pi pi-envelope"></i></div>
          <div>
            <p class="meta-label">CONTACT METHOD</p>
            <span class="meta-badge">{{ getPreferredContactMethod(selectedUser()!.preferredContactMethod) }}</span>
          </div>
        </div>
        <div class="meta-card">
          <div class="meta-icon blue"><i class="pi pi-globe"></i></div>
          <div>
            <p class="meta-label">LEAD SOURCE</p>
            <span class="meta-badge">{{ getLeadSourceLabel(selectedUser()!.leadSource) }}</span>
          </div>
        </div>
        <div class="meta-card">
          <div class="meta-icon green"><i class="pi pi-check-circle"></i></div>
          <div>
            <p class="meta-label">OPTIONAL FIELDS</p>
            <span class="meta-badge">{{ selectedUser()!.isOptionalFieldEnabled ? 'Yes' : 'No' }}</span>
          </div>
        </div>
      </div>
    </div>

    <hr class="modal-divider" />
    <div class="modal-section">
      <h6 class="section-title"><i class="pi pi-comment"></i> Message</h6>
      <p class="questions-text">{{ selectedUser()!.specificQuestionsOrRequests || 'No message provided' }}</p>
    </div>

  </div>
</div>
</div>
}